import { Attributes, Entity, System, SystemQueries } from "ecsy";
import { ConstraintData } from "../DataComponents/ConstraintData";
import { TransformData } from "../DataComponents/TransformData";
import { RopeRootTag } from "../TagComponents/RopeRootTag";

export class RopeRenderSystem extends System {
  static queries: SystemQueries = {
    rootRopes: {
      components: [RopeRootTag, ConstraintData, TransformData],
    },
  };

  mainCanvas: HTMLCanvasElement;
  canvasContext: CanvasRenderingContext2D;

  init(attributes?: Attributes): void {
    this.mainCanvas = attributes.mainCanvas;
    this.canvasContext = this.mainCanvas.getContext("2d");
  }

  execute(delta: number, time: number): void {
    // Draw all the ropes.
    this.queries.rootRopes.results.forEach((entity) => {
      // DFS stack.
      let stack: Array<Entity> = [];
      // Visited set.
      let visited: Set<Entity> = new Set();

      // Push the root onto the stack.
      stack.push(entity);

      while (stack.length > 0) {
        // Get the next entity.
        let currentEntity = stack.pop();

        // Add the entity to the visited set.
        visited.add(currentEntity);

        // Get the current entity's constraint data.
        let constraintData = currentEntity.getComponent(ConstraintData);
        // Get the current entity's transform data.
        let transformData = currentEntity.getComponent(TransformData);

        // Draw the rope.
        this.canvasContext.beginPath();
        this.canvasContext.strokeStyle = "black";
        this.canvasContext.lineWidth = 3;

        // Get the neighbor.
        let neighbors = constraintData.neighbors;

        // Push the neighbor onto the stack.
        neighbors.forEach((neighbor) => {
          // Continue if the neighbor has already been visited.
          if (visited.has(neighbor.target)) {
            return;
          }

          // Get the neighbor's transform data.
          let neighborTransformData =
            neighbor.target.getComponent(TransformData);
          // Draw the rope.
          this.canvasContext.moveTo(
            transformData.position.x,
            transformData.position.y
          );
          this.canvasContext.lineTo(
            neighborTransformData.position.x,
            neighborTransformData.position.y
          );

          // Push the neighbor onto the stack.
          stack.push(neighbor.target);
        });

        // Draw the rope.
        this.canvasContext.stroke();
      }
    });
  }
}
